import React from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import brandLogo from '../images/svgs/brand-logo-white.svg'

export default function Footer({ style }) {
    return (
        <footer style={style}>
			<Container>
			    <Row style={{ marginTop: 192, marginBottom: 171 }} className="text-center justify-content-center">
    				<Col xs='auto'>
    					{/* ENGINE DJ LOGO */}
    					<a href='https://enginedj.com/'>
    						<img src={brandLogo} alt='' width='298' height='45' />
    					</a>
    
    					{/* DIVIDER */}
    					<div 
    						className="d-block border-top border-dark mx-auto" 
    						style={{ marginTop: 32, marginBottom: 32, width: 48}} 
    					/>
    
    					{/* SUPPORT GRADIENT BUTTON */}
    					<a
    						href='https://enginedj.com/support'
    						className="d-inline-block text-white position-relative bg-black py-3 px-4"
    						style={{ borderRadius: 62, fontSize: 18 }}
    						css={{
    							'&::before': {
    								content: '""',
    								position: 'absolute',
    								background: 'linear-gradient(to right, #15F27B, #33A9EA)',
    								inset: -1,
    								zIndex: -1,
    								borderRadius: 'inherit'
    							}
    						}}
    					>
    						Support
    					</a>

						{/* Cookie Preferences */}
						<div id='teconsent' css={{
							display: 'block',
							marginTop: 32,
							fontSize: 12,
							'& > a': {
								color: '#B7B7B7'
							}
						}} />
    				</Col>
    			</Row>
			</Container>
        </footer>
    )
}